import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../store/auth-context";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  MenuItem,
  Snackbar,
  TextField,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { userService } from "../../services/UserService";
import { Link, useLocation } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import UserMenu from "../common/UserMenu";
import Notification from "../common/Notification";
import CloseIcon from "@material-ui/icons/Close";
import * as fs from "file-saver";
import UpdateInterestedUsersStatus from "./UpdateInterestedUsersStatus";
import ViewLogs from "./ViewLogs";

function ListOfInterestedUser() {
  const authCtx = useContext(AuthContext);
  const [t] = useTranslation();
  const location: any = useLocation();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("error");
  const [skip, setSkip] = useState<number>(0);
  const [take, setTake] = useState<number>(50);
  const [usersList, setusersList] = useState<any>([]);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [showExport, setShowExport] = useState<boolean>(false);
  const [exportValue, setExportValue] = useState<any>(0);
  const [total, setTotal] = useState<any>(0);
  const [editModal, setEditModal] = useState<boolean>(false);
  const [logsModal, setLogsModal] = useState<boolean>(false);
  const [interestedUserEditItem, setInterestedUserEditItem] = useState<any>();
  const [offerInterestId, setOfferInterestId] = useState<any>(0);
  const offerId = location.state.offerId;
  const offerName = location.state.offerName;

  const handleClose = () => setShowModal(false);

  useEffect(() => {
    fetchAllIterestedUsersList();
  }, []);

  const setpage = async () => {
    authCtx.toggleLoader(true);
    const nextUsersList = await userService.getInterastedUserForOffer(
      offerId,
      skip,
      take
    );
    if (nextUsersList && nextUsersList.users) {
      setusersList([...usersList, ...nextUsersList.users]);

      if (nextUsersList.users.length === 0) {
        setHasMore(false);
      } else {
        setHasMore(true);
        setSkip(skip + take);
      }
    } else {
      setusersList([]);
    }
    authCtx.toggleLoader(false);
  };

  const fetchAllIterestedUsersList = async () => {
    authCtx.toggleLoader(true);
    const res = await userService.getInterastedUserForOffer(
      offerId,
      skip,
      take
    );
    if (res && res.users && res.users.length > 0) {
      setusersList(res.users);
      setTotal(res.total);
      setSkip(skip + take);
    } else {
      setShowModal(true);
      setModalType("error");
      setModalText(t("Error"));
    }
    authCtx.toggleLoader(false);
  };

  const exportToExcel = async () => {
    authCtx.toggleLoader(true);
    let totalData: any = [];
    let recordsToSkip = 0;
    let takeItems = total > 500 ? 500 : total;
    let totalFetchedItems = 0;
    let res: any;
    setShowExport(true);

    while (totalFetchedItems < total) {
      res = await userService.getInterastedUserForOffer(
        offerId,
        recordsToSkip,
        takeItems
      );
      if (res && res.users && res.users.length > 0) {
        totalFetchedItems += res.users ? res.users.length : 0;
        recordsToSkip += takeItems;
        if (res.users && res.users.length > 0) {
          for (let i = 0; i < res.users.length; i++) {
            totalData.push(res.users[i]);
          }
        }
        let progressValue = (totalFetchedItems / total) * 100;
        setExportValue(progressValue > 100 ? 100 : progressValue);
      }
    }
    if (res && res.users) {
      let headers: string[] = [];
      headers = [
        "Name",
        "Mobile No.",
        "Date",
        "Email ID",
        "Status",
        "Region",
        "Updated By",
        "Updated On",
      ];

      const ExcelJS = require("exceljs");
      const workbook = new ExcelJS.Workbook();
      const dataForExcel = [];
      for (let i = 0; i < totalData.length; i++) {
        const item = totalData[i];
        const field = {
          name: item.firstName + " " + item.lastName,
          mobileNo: item.callingCode + "-" + item.phoneNumber,
          date: new Date(item.createdAt).toDateString(),
          email: item.email,
          status: item.status ? item.status : "New",
          region: item.region ? item.region : "NA",
          modifiedBy: item.modifiedByName ? item.modifiedByName : "",
          modifiedAt: item.modifiedAt
            ? new Date(item.modifiedAt).toDateString() +
              " - " +
              new Date(item.modifiedAt).toLocaleTimeString("en-US", {
                hour12: true,
                hour: "numeric",
                minute: "numeric",
              })
            : "",
        };
        dataForExcel.push(
          Object.values(field !== undefined && field !== null ? field : "")
        );
      }

      // Frozen worksheet
      const worksheet = workbook.addWorksheet(
        `Interested Users - ${offerName}`
      );

      //Adding Header Row
      let headerRow = worksheet.addRow(headers);
      headerRow.eachCell((cell: any, number: any) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "4167B8" },
          bgColor: { argb: "" },
        };
        cell.font = {
          bold: true,
          color: { argb: "FFFFFF" },
          size: 12,
        };
      });

      dataForExcel.forEach((d) => {
        worksheet.addRow(d);
      });

      autoSize(worksheet, 1, 5);

      workbook.xlsx.writeBuffer().then((data: any) => {
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fs.saveAs(blob, `Interested Users - ${offerName}.xlsx`);
      });
    }
    setShowExport(false);
    authCtx.toggleLoader(false);
  };

  // Auto width for column
  const autoSize = (sheet: any, fromRow: number, PixelPerColumn: number) => {
    const PIXELS_PER_EXCEL_WIDTH_UNIT = PixelPerColumn;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      return;
    }

    const maxColumnLengths: Array<number> = [];
    sheet.eachRow((row: any, rowNum: any) => {
      if (rowNum < fromRow) {
        return;
      }

      row.eachCell((cell: any, num: any) => {
        if (typeof cell.value === "string" || typeof cell.value === "number") {
          if (maxColumnLengths[num] === undefined) {
            maxColumnLengths[num] = 0;
          }

          const fontSize = cell.font && cell.font.size ? cell.font.size : 11;
          ctx.font = `${fontSize}pt Arial`;
          const metrics = ctx.measureText(cell.value);
          const cellWidth = metrics.width;

          maxColumnLengths[num] = Math.max(maxColumnLengths[num], cellWidth);

          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
      });
    });

    for (let i = 1; i <= sheet.columnCount; i++) {
      const col = sheet.getColumn(i);
      const width = maxColumnLengths[i];
      if (width) {
        col.width = width / PIXELS_PER_EXCEL_WIDTH_UNIT + 1;
      }
    }
  };

  const handleEditModalShow = (item: any) => {
    setInterestedUserEditItem(item);
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
  };

  const handleLogsModalShow = (item: any) => {
    setOfferInterestId(item.offerInterestId);
    setLogsModal(true);
  };

  const handleLogsModalClose = () => {
    setLogsModal(false);
  };

  const openMobileMenu = (e: any) => {
    e.preventDefault();

    document.getElementById("leftMenu")?.classList.remove("d-none");
  };
  return (
    <>
      <div className="main-content animate py-4 px-3 px-sm-4">
        <div className="d-sm-flex align-items-center mb-3">
          <a
            href="#"
            className="d-inline-block d-sm-none text-dark"
            onClick={(e) => openMobileMenu(e)}
          >
            <i className="material-icons-outlined me-2">menu</i>
          </a>

          <h3 className="fs-18-24">
            {t("Interested Users")} - {offerName}
          </h3>
          <div
            className={`${
              authCtx.selectedLanguage === "en" ? "ms-auto" : "mr-auto"
            } mw-90px`}
          >
            <Notification />
            <UserMenu />
          </div>
        </div>

        <div className="card border-0 shadow-sm rounded-3 mt-3">
          {usersList && usersList.length > 0 && (
            <div className="card-body px-4 ms-auto">
              <button
                className="btn btn-primary no-focus w-100"
                onClick={exportToExcel}
                disabled={showExport}
              >
                Export
              </button>
            </div>
          )}
          {usersList && usersList.length > 0 && (
            <div className="card-body p-4">
              {/* <h6 className="text-primary mb-4 ms-1">
                         {" "}
                         {t("List Of Administrators")}
                       </h6> */}
              <InfiniteScroll
                dataLength={usersList.length}
                next={setpage}
                hasMore={hasMore}
                loader={false}
              >
                <div className="table-responsive-lg">
                  <table className="table align-middle">
                    <thead>
                      <tr>
                        <th scope="col">{t("Name")}</th>
                        <th scope="col" className="d-none d-sm-table-cell">
                          {t("Mobile No.*")}
                        </th>
                        <th scope="col" className="d-none d-sm-table-cell">
                          {t("Date")}
                        </th>
                        <th scope="col" className="d-none d-sm-table-cell">
                          {t("Email ID*")}
                        </th>
                        <th scope="col" className="d-none d-sm-table-cell">
                          {t("Status")}
                        </th>
                        <th scope="col" className="d-none d-sm-table-cell">
                          {t("Region")}
                        </th>
                        <th scope="col" className="d-none d-sm-table-cell">
                          {t("Action")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {usersList &&
                        usersList.length > 0 &&
                        usersList.map((item: any) => (
                          <tr key={item.offerInterestId}>
                            <td>
                              {item.firstName} {item.lastName}
                            </td>
                            <td className="d-none d-sm-table-cell">
                              {item.callingCode}-{item.phoneNumber}
                            </td>
                            <td className="d-none d-sm-table-cell">
                              {new Date(item.createdAt).toDateString()}
                            </td>
                            <td className="d-none d-sm-table-cell">
                              {item.email}
                            </td>
                            <td className="d-none d-sm-table-cell">
                              {item.status ? item.status : "New"}
                            </td>
                            <td className="d-none d-sm-table-cell">
                              {item.region ? item.region : "NA"}
                            </td>
                            <td className="d-none d-sm-table-cell">
                              <Link
                                to="#"
                                className="me-2"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEditModalShow(item);
                                }}
                              >
                                <i className="material-icons-outlined">edit</i>
                              </Link>
                              {item.modifiedByName &&
                                item.modifiedByName !== "" && (
                                  <Link
                                    to="#"
                                    className="me-2"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleLogsModalShow(item);
                                    }}
                                  >
                                    <i className="material-icons-outlined">
                                      history
                                    </i>
                                  </Link>
                                )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </InfiniteScroll>
            </div>
          )}
          {usersList && usersList.length === 0 && (
            <div className="card-body p-4">
              <div className="text-center text-999">
                {" "}
                <i className="material-icons-outlined fs-1"> info </i>
                <p className="fs-6">{t("No record found")}</p>
              </div>
            </div>
          )}
        </div>
      </div>

      <Dialog
        open={editModal}
        fullWidth={true}
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Update Status
          <IconButton
            className="float-end p-1"
            aria-label="close"
            onClick={handleEditModalClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="pt-0">
          <DialogContentText id="alert-dialog-description">
            <div className="mt-4">
              <UpdateInterestedUsersStatus
                interestedUserEditItem={interestedUserEditItem}
                handleEditModalClose={handleEditModalClose}
                setusersList={setusersList}
                usersList={usersList}
                setModalText={setModalText}
                setModalType={setModalType}
                setShowModal={setShowModal}
              />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={logsModal}
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Activities
          <IconButton
            className="float-end p-1"
            aria-label="close"
            onClick={handleLogsModalClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="pt-0">
          <DialogContentText id="alert-dialog-description">
            <div className="mt-4">
              <ViewLogs offerInterestId={offerInterestId} />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {modalType === "error" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
      {modalType === "success" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="success">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default ListOfInterestedUser;
